import { render, staticRenderFns } from "./recipient-email.vue?vue&type=template&id=4d3dcf5f"
import script from "./recipient-email.vue?vue&type=script&lang=js"
export * from "./recipient-email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports